var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolologo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 690 690",
    style: {
      enableBackground: "new 0 0 690 690"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC9EC;}\n\t.st1{fill:#F6B85B;}\n\t.st2{fill:#4A5B64;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M676,587.5c0-39.8-148.2-72-331-72c-182.8,0-331,32.2-331,72c0,39.8,148.2,72,331,72 C527.8,659.5,676,627.3,676,587.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.7,33.1c22.1-5.1,45.9-2.6,66.4,7.1C412,49,428,63.9,438.2,82c10.2,18,14.9,39.3,12.4,59.9 c-2.4,17.8-10.6,34.3-20.3,49.2c-8.7,13.1-19,25.1-28.9,37.2c-17,20.5-34.4,40.8-51.7,61.1c-20-21.4-39.8-43-59-65.1 c-12.8-14.8-25.3-30.3-33.3-48.4c-8.3-18.1-11.1-38.6-8.4-58.3c2.9-20.8,12.6-40.6,27.1-55.8C289.7,47.6,307.5,37.4,326.7,33.1  M344.8,84.4c-15,1.3-29,10-37,22.6c-6.6,10-9.2,22.5-7.4,34.4c1.8,12.4,8.5,24,18.4,31.8c7.9,6.3,17.8,10.1,27.9,10.7 c10.1,0.6,20.3-1.9,28.9-7.1c7.9-4.8,14.4-11.8,18.6-20c5.7-11.1,7-24.4,3.6-36.3c-3.4-12.3-11.9-23.2-23-29.6 C365.8,85.6,355.1,83.3,344.8,84.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M535.9,452.3l-4.2-12.7c-2.4-7-9.8-12.6-16.8-12.6h-15.5c-11.6-33.1-25.8-73-29.9-82.3 c-6.4-14.6-26.9-21.1-38.2-24.3c0,0-18.8-7.3-81.7-7.3c-62.8,0-81.7,7.3-81.7,7.3c-13.2,4.5-31.6,10.8-38.8,25 c-3.4,6.6-17.9,47.7-29.6,81.7h-15.2c-6.9,0-14.4,5.6-16.7,12.6l-4.3,12.7c-2.3,7,1.3,12.7,8.2,12.7h15c-1.9,5.7-3.1,9.2-3.1,9.2 c-1.2,2.1-2.1,11.5-2.1,14v115.3c0,7.4,5.9,13.4,13.2,13.4H243c7.3,0,13.2-6,13.2-13.4V579h187v24.5c0,7.4,5.9,13.4,13.2,13.4h48.4 c7.3,0,13.2-6,13.2-13.4V488.2c0-2.5-0.8-12-2.1-14c0,0-1.2-3.4-3.2-9.2h15C534.6,465,538.3,459.3,535.9,452.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.9,523h-20c-17.9,0-35.8-2.5-35.8-14v-14c0-13.5,7.7-14,16-14c8.2,0,24.3,7,34.9,11.8 c11.5,5.3,24.4,9.7,24.4,18.4C275.4,519.2,271,523,255.9,523"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228,432.1c9.8-41.5,20.5-64.9,22.9-71.5c1.9-4.7,3.7-19.4,98.7-19.4s97.3,16.8,97.5,16.9 c2.9,8.9,14.5,35.7,23.8,73.9c0,0-40.1,13.9-121.3,13.9C268.4,446,228,432.1,228,432.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M423.8,511.1c0-8.7,13-13.1,24.5-18.4c10.6-4.8,26.7-11.8,34.8-11.8c8.3,0,16.1,0.5,16.1,14v14 c0,11.6-17.9,14-35.8,14h-20C428.3,523,423.8,519.2,423.8,511.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolologo);
export default __webpack_public_path__ + "static/media/solologo.0c1a0eb605b4d97786977937ce3c948c.svg";
export { ForwardRef as ReactComponent };